import React from "react";

class Programming 
extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <section className="section">
          <div className="container">
            <h1 className="title"> Programming </h1>
            <div className="columns">
              <div className="column">
                <div className="box has-background-white content">
                 <img alt="" src="/img/program2026.jpg"></img>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Programming;
